import { render, staticRenderFns } from "./testBlockSet.vue?vue&type=template&id=5579e39e&scoped=true"
import script from "./testBlockSet.vue?vue&type=script&lang=js"
export * from "./testBlockSet.vue?vue&type=script&lang=js"
import style0 from "./testBlockSet.vue?vue&type=style&index=0&id=5579e39e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579e39e",
  null
  
)

export default component.exports